import { Guides } from "./components/guides.js";
import { OldBrowserChecker } from "./components/oldBrowserChecker.js";

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

const isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const isDesktop = window.matchMedia("(max-width: 1000px)");

/* -------------------------------------------------- */
/* 👵 Check for old browsers */
/* -------------------------------------------------- */

new OldBrowserChecker();

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides();

/* -------------------------------------------------- */
/* 📱 Mobile menu */
/* -------------------------------------------------- */

const menuToggle = document.querySelector(".menu-toggle");

if (menuToggle) {
  const menuOverlay = document.querySelector(".menu-overlay"); // native dialog element
  const closeMenuButton = menuOverlay.querySelector(
    ".menu-overlay__close-button"
  );

  menuToggle.addEventListener("click", () => {
    menuOverlay.showModal();
  });

  closeMenuButton.addEventListener("click", () => {
    menuOverlay.close();
  });

  // Once desktop media query no longer matches, close the menu
  isDesktop.addEventListener("change", (e) => {
    if (!e.matches) {
      menuOverlay.close();
    }
  });
}
